import { collections } from "@/mocks/home";

export default function CollectionIndex() {
  return (
    <section id="collections" className="w-full px-4 md:px-8 mt-14 md:mt-20">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <span className="font-label text-xs tracking-[0.3em] text-accent-700">合集索引</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            把线索整理成可以反复翻阅的合集
          </h2>
        </div>
        <p className="font-label text-sm text-foreground-500 max-w-md">
          单条爆料会过期，成体系的合集才能被检索、被引用，也更容易看出前后矛盾的地方。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {collections.map((item, index) => (
          <a
            key={item.title}
            href="#collections"
            className={`group flex flex-col rounded-lg overflow-hidden border border-background-200/80 hover:border-primary-300 transition-colors cursor-pointer ${
              index === 0 ? "sm:col-span-2 lg:col-span-1 bg-background-100" : "bg-background-50"
            }`}
          >
            <div className="relative w-full h-[170px] bg-background-200">
              <img
                src={item.image}
                alt={`黑料看料 合集：${item.title}`}
                title={`黑料看料 ${item.title} 合集索引`}
                className="w-full h-full object-top object-cover group-hover:scale-[1.03] transition-transform duration-500"
              />
              <span className="absolute top-3 left-3 px-2.5 py-1 rounded bg-background-50/92 backdrop-blur font-label text-[11px] text-foreground-700">
                {item.count} {item.unit} · {item.updated}
              </span>
            </div>
            <div className="flex flex-col flex-1 p-4 md:p-5">
              <h3 className="font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600 flex-1">
                {item.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 font-label text-xs text-primary-600 whitespace-nowrap">
                打开合集
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}